import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  inject,
} from '@angular/core'
import { MatIcon } from '@angular/material/icon'
import { MatSort, MatSortHeader } from '@angular/material/sort'
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
} from '@angular/material/table'
import { MatTooltip } from '@angular/material/tooltip'
import { DataContextBuilder, ElderTableComponent, IDataContext, Sort } from '@elderbyte/ngx-starter'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { ProdOrderTransit } from '../prod-order-transit'
import { ProdOrderTransitFilterBuilder } from '../prod-order-transit-filter-builder'
import { ProdOrderTransitService } from '../prod-order-transit.service'

@Component({
  selector: 'app-prod-order-transit-browser',
  templateUrl: './prod-order-transit-browser.component.html',
  styleUrls: ['./prod-order-transit-browser.component.scss'],
  imports: [
    ElderTableComponent,
    MatSort,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatSortHeader,
    MatCellDef,
    MatCell,
    MatTooltip,
    MatIcon,
    ElderTranslatePipe,
  ],
})
export class ProdOrderTransitBrowserComponent implements OnDestroy {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public readonly data: IDataContext<ProdOrderTransit>
  private prodOrderTransitService = inject(ProdOrderTransitService)

  @Output()
  public itemClick = new EventEmitter<ProdOrderTransit>()

  @Output()
  public selectionSingleChange = new EventEmitter<ProdOrderTransit>()

  @Output()
  public selectionChange = new EventEmitter<ProdOrderTransit[]>()

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    this.data = DataContextBuilder.start<ProdOrderTransit>()
      .pageSize(30)
      .reloadOnLocalChanges()
      .autoStartOnFiltersAll(
        [ProdOrderTransitFilterBuilder.PROD_ORDER_IDS_KEY],
        [new Sort('targetFacilityId', 'asc'), new Sort('sourceFacilityId', 'asc')]
      )
      .build(this.prodOrderTransitService)
  }

  /***************************************************************************
   *                                                                         *
   * Life Cycle                                                              *
   *                                                                         *
   **************************************************************************/

  public ngOnDestroy(): void {
    if (this.data) {
      this.data.close()
    }
  }

  /***************************************************************************
   *                                                                         *
   * Properties                                                              *
   *                                                                         *
   **************************************************************************/

  @Input()
  public set prodOrderId(prodOrderId: string) {
    if (prodOrderId) {
      const prodOrderFilter = ProdOrderTransitFilterBuilder.prodOrders(prodOrderId)
      this.data.filter.updateFilter(prodOrderFilter)
    }
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public onItemClick(order: ProdOrderTransit): void {
    this.itemClick.next(order)
  }

  public onSelectionSingleChange(selection: ProdOrderTransit): void {
    this.selectionSingleChange.next(selection)
  }

  public onSelectionChange(selection: ProdOrderTransit[]): void {
    this.selectionChange.next(selection)
  }

  /***************************************************************************
   *                                                                         *
   * Private Methods                                                         *
   *                                                                         *
   **************************************************************************/
}
